import { NgModule } from '@angular/core';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatCardModule, MatMenuModule, MatSliderModule, MatButtonToggleModule, MatToolbarModule, MatSidenavModule, MatListModule, MatTabsModule, MatTooltipModule, MatDialogModule, MatChipsModule, MatStepperModule, MatNativeDateModule, MatRadioModule, MatProgressSpinnerModule, MatProgressBarModule, MatCheckboxModule, MatSnackBarModule, MatDatepickerModule, MatSelectModule, MatAutocompleteModule, MatSlideToggleModule, MatTableModule, MatPaginatorModule, MatSortModule, MatExpansionModule, MatDialog } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FooterComponent } from './footer/footer.component';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: false,
  decimal: ".",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ","
};

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    FlexLayoutModule,
    MatDialogModule,
    MatChipsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    TranslateModule,
    MatNativeDateModule,
    NgSelectModule,
    CurrencyMaskModule
  ],
  declarations: [
    FooterComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatListModule,
    FlexLayoutModule,
    MatDialogModule,
    MatChipsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatSelectModule,
    MatTableModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    TranslateModule,
    NgSelectModule,
    CurrencyMaskModule,

    FooterComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ]
})
export class SharedModule { }
